import { useGetWalletsPoliciesQuery } from '../api';

export const useWalletPolicies = () => {
  const {
    data: walletPolicies,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useGetWalletsPoliciesQuery('', {
    skip: false,
  });
  return { walletPolicies, isLoading, isError, error, isFetching, refetch };
};
